/* eslint-disable react/no-multi-comp, react/prop-types */
import React from 'react';

// Components
import Tooltip from 'components/widgets/overlays/tooltip';

// Assets
import xeroIcon from 'assets/images/xero_icon.png';

// Constants
import { XERO_CHARGE_LINK, XERO_LEGACY_CHARGE_LINK, XERO_RETURN_LINK, XERO_INVOICE_LINK } from 'constants';


export function XeroChargeLink({ xeroId, ...props }) {
  return (
    <XeroLink link={`${XERO_CHARGE_LINK}${xeroId}`} tooltipTitle="View charge in Xero" {...props} />
  );
}


export function XeroLegacyChargeLink({ xeroId, ...props }) {
  return (
    <XeroLink link={`${XERO_LEGACY_CHARGE_LINK}${xeroId}`} tooltipTitle="View charge in Xero" {...props} />
  );
}


export function XeroReturnLink({ xeroId, ...props }) {
  return (
    <XeroLink link={`${XERO_RETURN_LINK}${xeroId}`} tooltipTitle="View return in Xero" {...props} />
  );
}


export function XeroInvoiceLink({ xeroId, ...props }) {
  return (
    <XeroLink link={`${XERO_INVOICE_LINK}${xeroId}`} tooltipTitle="View invoice in Xero" {...props} />
  );
}


function XeroLink({ link, tooltipTitle, ...props }) {
  return (
    <a href={link} target="_blank" {...props}>
      <Tooltip title={tooltipTitle} className="inline-block">
        <img src={xeroIcon} className="xero-icon" height="20" alt="Xero icon" />
      </Tooltip>
    </a>
  );
}



// WEBPACK FOOTER //
// ./app/components/widgets/icons/link-icons/xero-link.js